/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Ip_Item_2Inputs */

const es_tyc_ip_item_2 = /** @type {(inputs: Tyc_Ip_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se le concede una licencia limitada, revocable, no exclusiva e intransferible para usar el Servicio unicamente conforme a estos Terminos.`)
};

const en_tyc_ip_item_2 = /** @type {(inputs: Tyc_Ip_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are granted a limited, revocable, non-exclusive, and non-transferable license to use the Service solely in accordance with these Terms.`)
};

/**
* | output |
* | --- |
* | "You are granted a limited, revocable, non-exclusive, and non-transferable license to use the Service solely in accordance with these Terms." |
*
* @param {Tyc_Ip_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_ip_item_2 = /** @type {((inputs?: Tyc_Ip_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Ip_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_ip_item_2(inputs)
	return en_tyc_ip_item_2(inputs)
});
export { tyc_ip_item_2 as "tyc.ip.item_2" }